<template>
    <div class="b-lang-selector" :class="classes" v-click-outside="handleClickOutside" @click="handleClick"
        @mouseleave="handleMouseLeave">
        <template v-for="option in options">
            <label :key="option.id" v-if="isOpen || innerModel === option.id" class="b-lang-selector__option">
                <input type="radio" v-model="innerModel" :value="option.id" />
                {{ option.label }}
            </label>
        </template>
    </div>
</template>

<script>
import clickOutside from '@/directives/click-outside';

export default {
    name: 'b-lang-selector',
    directives: {
        clickOutside,
    },
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        options: {
            type: Array,
            default: () => [], // { id: string|number, label: string}[]
        },

        expandDirection: {
            type: String,
            default: 'left',
            validator: (value) => ['left', 'right'].includes(value)
        },
    },
    data() {
        return {
            isOpen: false,
            closeTimeout: null,
        }
    },
    computed: {
        classes() {
            return {
                'is-open': this.isOpen,
                'b-lang-selector--left': this.expandDirection === 'left',
                'b-lang-selector--right': this.expandDirection === 'right',
            }
        },
        innerModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        handleClick() {
            clearTimeout(this.closeTimeout);
            this.isOpen = true;
        },
        handleClickOutside() {
            clearTimeout(this.closeTimeout);
            this.isOpen = false;
        },
        handleMouseLeave() {
            this.closeTimeout = setTimeout(() => {
                this.isOpen = false;
            }, 1500);
        }
    }
}
</script>

<style lang="scss">
.b-lang-selector {
    --size-option: 36px;
    --gap: 4px;
    display: inline-flex;
    justify-content: flex-end;
    gap: var(--gap);
    padding: var(--gap);
    position: relative;
    isolation: isolate;

    &:after {
        content: '';
        position: absolute;
        z-index: -1;
        inset: 0;
        background-color: var(--color-primary-600);
        border-radius: 100px;
    }

    &:not(.is-open):hover {
        &.b-lang-selector--left {
            &:after {
                left: -15%;
            }
        }

        &.b-lang-selector--right {
            &:after {
                right: -15%;
            }
        }
    }

    &.is-open {
        &:after {
            background-color: var(--color-primary-700);
        }
    }

    input {
        display: none;
    }
}

.b-lang-selector__option {
    width: var(--size-option);
    height: var(--size-option);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    cursor: pointer;
    border-radius: 100px;
    font-size: var(--font-size-s);
    color: #fff;

    //unchecked
    &:has(:not(input:checked)) {
        &:is(:hover, :focus, :active) {
            background-color: var(--color-primary-600);
        }
    }

    //checked
    &:has(input:checked) {
        background-color: var(--color-primary-600);
    }
}
</style>